import React, { useState } from "react";
import dataService from "../../services/dataService";
import ProductListEnumType from "../../../enums/productListEnumType";
import CloseIcon from '@mui/icons-material/Close';
import { useGlobalNotification } from "@/app/components/header/GlobalNotificationContext";

interface SidebarCreateNewEstimateProps {
  open: boolean;
  onClose: () => void;
  createNewList: (createdListId: string, productListType: ProductListEnumType, newListName: string) => void;
}

const SidebarCreateNewEstimate: React.FC<SidebarCreateNewEstimateProps> = ({ open, onClose, createNewList }) => {
  const [type, setType] = useState<"Template" | "Estimate">("Template");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const { setNotification } = useGlobalNotification();


  const handleSave = async () => {
    if (!name.trim()) {
      return;
    }
    onClose();
    const response = await dataService.createNewEstimateOrTemplate(type == "Template" ? ProductListEnumType.PrivateList : ProductListEnumType.QuoteList, name.trim(), description.trim());
    if (response.success && (response.data.errorMessage == null || response.data.errorMessage?.trim() === "")) {
      createNewList(response.data.id?.toString() ?? "0", type === "Template" ? ProductListEnumType.PrivateList : ProductListEnumType.QuoteList, name);
    }   
    else if (response.data.errorMessage && response.data.errorMessage.trim() !== "") {
      setNotification(response.data.errorMessage, "error");
    }
    else {
      alert(response.error || "Failed to create estimate or template.");
    }
  };

  return (
    <div className={`sidebarCreateNewEstimateContainer sidebar ${open ? 'open' : ''}`}>
      <div className="sidebarClose" onClick={() => onClose()}>
        <CloseIcon />
      </div>
      <div className="sidebarAddNewListBody sidebarBody">
        <h3 className="title">Create a new Estimate or Template</h3>

        <div style={{ margin: "15px 0px" }}>
          <label className="radioLabel">
            <input
              type="radio"
              checked={type === "Template"}
              onChange={() => setType("Template")}
            />{" "}
            Template
          </label>
          <label className="radioLabel" style={{ marginLeft: "16px" }}>
            <input
              type="radio"
              checked={type === "Estimate"}
              onChange={() => setType("Estimate")}
            />{" "}
            Homeowner Estimate
          </label>
        </div>

        <div className="templateDetails" style={{ marginBottom: "20px" }}>
          <input
            placeholder="Template Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={50} />
          <label className="textSmall">Maximum of 50 characters</label>
        </div>

        <div className="templateDetails" style={{ marginBottom: "20px" }} >
          <textarea
            placeholder="Add Description (optional)"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={150}
            style={{ minHeight: "200px" }}
            rows={4} />
          <label className="textSmall">Maximum of 150 characters</label>
        </div>

        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <button
            className="handCursor blueButtonOutline"
            onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default SidebarCreateNewEstimate;